import React, { useState, useEffect } from "react";
import CardComponent from "./lib/CardComponent";
import { format } from "date-fns";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import { Occupations, Gross_Annual_income } from ".";
import {
  validateTINNumber,
  getTinCountries,
  getTinIdentificationList,
  getCountriesList,
  getStatesList,
  storeFatcaDetails,
  storeApplicantParams,
  getKycDetails,
  getCitiesList as getCitiesByState,
  getRelationShipList,
  storeAddress,
} from "../../../../store/actions";
import { panRegex } from ".";
import CustomLoader from "../../../forms/Loader";
import { KycNotDoneDialog } from "../../customModal";
import CustomizedSelect from "../customizedSelect";
import { Input } from "../../../forms/input";
import { NEW_TRANSACTION_URL } from "..";
import { RadioButton } from "./lib/Radiobutton";

const FatcaDetails = (props) => {
  const checkReduxStore = () => {
    if (props.fatcaDetails.i_Occpn) {
      const { fatcaDetails } = props;
      const {
        i_Occpn,
        i_income,
        FCountryofBirth,
        FNationality,
        i_invpin,
        FPEP,
        FPREP,
        FTaxResident,
        FForeignTaxType,
        FForeignTaxId,
        i_SOccpn,
        i_Sincome,
        SCountryofBirth,
        SNationality,
        i_invpin2,
        SForeignTaxType,
        STaxResident,
        SForeignTaxId,
        SPEP,
        SPREP,
        i_TOccpn,
        i_Tincome,
        TCountryofBirth,
        TNationality,
        i_invpin3,
        TForeignTaxType,
        TTaxResident,
        TForeignTaxId,
        TPEP,
        TPREP,
      } = fatcaDetails;
      setCategoryOccupation((prev) => {
        return {
          ...prev,
          categoryoccupationprimary: { value: i_Occpn },
        };
      });
      setGross_Annual_Income((prev) => {
        return {
          ...prev,
          gross_annual_incomeprimary: { value: i_income },
        };
      });
      setcountryselected((prev) => {
        return {
          ...prev,
          countryofbirth: { value: FCountryofBirth },
          nationality: { value: FNationality },
        };
      });
      setPincode((prev) => {
        return {
          ...prev,
          value: { value: i_invpin },
        };
      });
      setPolitically_Exposed_Applicant((prev) => {
        return {
          ...prev,
          primary: FPEP,
        };
      });
      setPolitically_Exposed_Relative((prev) => {
        return {
          ...prev,
          primary: FPREP,
        };
      });
      setTax_resident((prev) => {
        return {
          ...prev,
          primary: FTaxResident,
        };
      });
      if (FTaxResident === "yes") {
                const matchedCountry = tincountriesList.find(
          (c) => c.value === FForeignTaxType
        );
      
        const matchedIdType = tinidentificationList.find(
          (i) => i.idTypeCode === fatcaDetails.FFTIdentificationType
        );
      
        setforeign_tax_id_no((prev) => ({
          ...prev,
          primary: { value: FForeignTaxId },
        }));
      
        settax_resident_option((prev) => ({
          ...prev,
          primary: {
            value: FForeignTaxType,
            countryCode: matchedCountry ? matchedCountry.countryCode : "",
          },
        }));
      
        settin_identification_type((prev) => ({
          ...prev,
          primary: {
            value: matchedIdType ? matchedIdType.value : "", // UI display
            idTypeCode: fatcaDetails.FFTIdentificationType, // stored code
          },
        }));
      }

      if (!!props.applicantparams && !!props.applicantparams.i_pangno2) {
        setCategoryOccupation((prev) => {
          return {
            ...prev,
            categoryoccupationjoint1: { value: i_SOccpn },
          };
        });
        setGross_Annual_Income((prev) => {
          return {
            ...prev,
            gross_annual_incomejoint1: { value: i_Sincome },
          };
        });
        setcountryselected((prev) => {
          return {
            ...prev,
            countryofbirthjoint1: { value: SCountryofBirth },
            nationalityjoint1: { value: SNationality },
          };
        });
        setPincode((prev) => {
          return {
            ...prev,
            value_joint1: { value: i_invpin2 },
          };
        });
        setPolitically_Exposed_Applicant((prev) => {
          return {
            ...prev,
            joint1: SPEP,
          };
        });
        setPolitically_Exposed_Relative((prev) => {
          return {
            ...prev,
            joint1: SPREP,
          };
        });
        setTax_resident((prev) => {
          return {
            ...prev,
            joint1: STaxResident,
          };
        });
        if (STaxResident === "yes") {
          const matchedCountry = tincountriesList.find(
            (c) => c.value === SForeignTaxType
          );
        
          const matchedIdType = tinidentificationList.find(
            (i) => i.idTypeCode === fatcaDetails.SFTIdentificationType
          );
        
          setforeign_tax_id_no((prev) => ({
            ...prev,
            joint1: { value: SForeignTaxId },
          }));
        
          settax_resident_option((prev) => ({
            ...prev,
            joint1: {
              value: SForeignTaxType,
              countryCode: matchedCountry ? matchedCountry.countryCode : "",
            },
          }));
        
          settin_identification_type((prev) => ({
            ...prev,
            joint1: {
              value: matchedIdType ? matchedIdType.value : "",
              idTypeCode: fatcaDetails.SFTIdentificationType,
            },
          }));

        }
      }
      if (!!props.applicantparams && !!props.applicantparams.i_pangno3) {
        setCategoryOccupation((prev) => {
          return {
            ...prev,
            categoryoccupationjoint2: { value: i_TOccpn },
          };
        });
        setGross_Annual_Income((prev) => {
          return {
            ...prev,
            gross_annual_incomejoint2: { value: i_Tincome },
          };
        });
        setcountryselected((prev) => {
          return {
            ...prev,
            countryofbirthjoint2: { value: TCountryofBirth },
            nationalityjoint2: { value: TNationality },
          };
        });
        setPincode((prev) => {
          return {
            ...prev,
            value_joint2: { value: i_invpin3 },
          };
        });
        setPolitically_Exposed_Applicant((prev) => {
          return {
            ...prev,
            joint2: TPEP,
          };
        });
        setPolitically_Exposed_Relative((prev) => {
          return {
            ...prev,
            joint2: TPREP,
          };
        });
        setTax_resident((prev) => {
          return {
            ...prev,
            joint2: TTaxResident,
          };
        });
        if (TTaxResident === "yes") {
          const matchedCountry = tincountriesList.find(
            (c) => c.value === TForeignTaxType
          );
        
          const matchedIdType = tinidentificationList.find(
            (i) => i.idTypeCode === fatcaDetails.TFTIdentificationType
          );
        
          setforeign_tax_id_no((prev) => ({
            ...prev,
            joint2: { value: TForeignTaxId },
          }));
        
          settax_resident_option((prev) => ({
            ...prev,
            joint2: {
              value: TForeignTaxType,
              countryCode: matchedCountry ? matchedCountry.countryCode : "",
            },
          }));
        
          settin_identification_type((prev) => ({
            ...prev,
            joint2: {
              value: matchedIdType ? matchedIdType.value : "",
              idTypeCode: fatcaDetails.TFTIdentificationType,
            },
          }));

        }
      }
    }
  };
  const [isLoading, setIsLoading] = useState(false);
  const [categoryoccupation, setCategoryOccupation] = useState({
    categoryoccupationprimary: { value: "" },
    categoryoccupationjoint1: { value: "" },
    categoryoccupationjoint2: { value: "" },
  });
  const [gross_annual_income, setGross_Annual_Income] = useState({
    gross_annual_incomeprimary: { value: "" },
    gross_annual_incomejoint1: { value: "" },
    gross_annual_incomejoint2: { value: "" },
  });
  const [countriesList, setcountriesList] = useState([]);
  const [tincountriesList, settincountriesList] = useState([]);
  const [tinidentificationList, settinidentificationList] = useState([]);

  const [foreigncountriesList, setforeigncountriesList] = useState([]);
  const [countryselected, setcountryselected] = useState({
    countryofbirth: { value: "" },
    nationality: { value: "" },
    countryofbirthjoint1: { value: "" },
    nationalityjoint1: { value: "" },
    countryofbirthjoint2: { value: "" },
    nationalityjoint2: { value: "" },
  });
  const [tax_resident, setTax_resident] = useState({
    primary: props.applicantparams.i_category === "20" ? "yes" : "no",
    joint1: props.applicantparams.i_category2 === "20" ? "yes" : "no",
    joint2: props.applicantparams.i_category3 === "20" ? "yes" : "no",
  });
  const [politically_exposed_applicant, setPolitically_Exposed_Applicant] =
    useState({ primary: "no", joint1: "no", joint2: "no" });
  const [politically_exposed_relative, setPolitically_Exposed_Relative] =
    useState({ primary: "no", joint1: "no", joint2: "no" });
  const [tax_resident_option, settax_resident_option] = useState({
    primary: { value: "",countryCode:"" },
    joint1: { value: "",countryCode:""  },
    joint2: { value: "",countryCode:""  },
  });
  const [foreign_tax_id_no, setforeign_tax_id_no] = useState({
    primary: { value: "" },
    joint1: { value: "" },
    joint2: { value: "" },
  });
  const [tin_identification_type, settin_identification_type] = useState({
    primary: { value: "",idTypeCode:"" },
    joint1: { value: "",idTypeCode:"" },
    joint2: { value: "" ,idTypeCode:""},
  });
  const [pincode, setPincode] = useState({
    value: { value: "" },
    value_joint1: { value: "" },
    value_joint2: { value: "" },
  });
  const [openModal, setOpenModal] = useState(false);
  const [panverification, setPanverification] = useState(false);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    firstRender();
  }, []);
  const firstRender = async () => {
    await getLists();
    await prefillFormValues();
  };

  useEffect(() => {
    if (tincountriesList.length > 0 && tinidentificationList.length > 0) {
      checkReduxStore();
    }
  }, [tincountriesList, tinidentificationList]);

  const getLists = async () => {
    setIsLoading(true);
    const tinCountries = await props.getTinCountries()
    const tinIdentificationList = await props.getTinIdentificationList()
    const tinIdentificationOptions =
    tinIdentificationList?.resData
      ?.sort((a, b) =>
        a.identificationType.localeCompare(b.identificationType)
      )
      .map((item) => ({
        label: item.identificationType,
        value: item.identificationType,   
        idTypeCode: item.idTypeCode,      
      })) || [];
    const tincountriesList =  tinCountries?.resData
    ?.sort((a, b) => a.countryName.localeCompare(b.countryName)) 
    .filter((country) => country.countryName.toLowerCase() !== "india")
    .map((country) => ({
      label: country.countryName,
        value: country.countryName,
      countryCode: country.countryCode,
    })) || [];
    settinidentificationList(tinIdentificationOptions)
    settincountriesList(tincountriesList)
    const countriesResponse = await props.getCountriesList();
    const Countries = countriesResponse.Dtinformation?.filter((country) => {
      return country.countryValue !== "USA" && country.countryValue !== "CANADA";
    });
  
    const countriesList = Countries.map((country) => {
      return { label: country.country_name, value: country.country_name };
    });
    const ForeignCountrires = Countries.map((country) => {
      return { label: country.country_name, value: country.country_name };
    });
    
    setcountriesList(
      countriesList.length > 0
        ? countriesList
        : [{ label: "India", value: "India" }]
    );
    
    const RemomovingIndia = { label: "India", value: "India" };
    ForeignCountrires.splice(
      ForeignCountrires.findIndex((a) => a.value === RemomovingIndia.value),
      1
    );
    setforeigncountriesList(ForeignCountrires);
    setIsLoading(false);
  };
  const prefillFormValues = async () => {
    if (!props.fatcaDetails.i_invpin) {
      if (
        (!!props.store_pan && props.store_pan.length > 0) ||
        props.applicantparams.typeofinvestor === "M"
      ) {
        const kycResponse = await props.getKycDetails({ pan: props.store_pan });
        if (!!kycResponse) {
          const {
            country,
            pin,
            GrossAnnualIncome,
            app_occ,
            add1,
            add2,
            add3,
            state,
            city,
          } = kycResponse.DtData[0];
          setCategoryOccupation((prev) => {
            return {
              ...prev,
              categoryoccupationprimary: { value: app_occ },
            };
          });
          setPincode((prev) => {
            return {
              ...prev,
              value: { value: pin },
            };
          });
          setGross_Annual_Income((prev) => {
            return {
              ...prev,
              gross_annual_incomeprimary: { value: GrossAnnualIncome },
            };
          });
          const countryvalue =
            country?.charAt(0).toUpperCase() + country?.slice(1)?.toLowerCase();
          setcountryselected((prev) => {
            return {
              ...prev,
              nationality: { value: countryvalue },
              countryofbirth: { value: countryvalue },
            };
          });
          const address = add1 + add2 + add3;
          const convertingcountry = country?.toLowerCase();
          const restOfGreeting = convertingcountry?.slice(1);
          const convertcountry =convertingcountry? convertingcountry[0]?.toUpperCase():"";
          const newGreeting = convertcountry + restOfGreeting;
          const Address = {
            state: state,
            city: city,
            country: newGreeting,
            pincode: pin,
            address: address,
          };
          props.storeAddress(Address);
          setcountryselected({
            ...countryselected,
            nationality: { value: countryvalue },
            countryofbirth: { value: countryvalue },
          });
        }
      }
    }
    // setIsLoading(true)
    if (
      !!props.applicantparams.i_pangno2 &&
      props.applicantparams.i_pangno2.length > 0
    ) {
      const kycResponse = await props.getKycDetails({
        pan: props.applicantparams.i_pangno2,
      });
      // const { DtData } = !!kycResponse ?kycResponse :[]
      // const kycDetails = !!DtData[0] ?DtData[0] :{} ;
      if (!!kycResponse) {
        const { country, pin, GrossAnnualIncome, app_occ } =
          kycResponse.DtData[0];
        setCategoryOccupation((prev) => {
          return {
            ...prev,
            categoryoccupationjoint1: { value: app_occ },
          };
        });
        setPincode((prev) => {
          return {
            ...prev,
            value_joint1: { value: pin },
          };
        });
        setGross_Annual_Income((prev) => {
          return {
            ...prev,
            gross_annual_incomejoint1: { value: GrossAnnualIncome },
          };
        });
        const countryvalue =
          country.charAt(0).toUpperCase() + country.slice(1).toLowerCase();
        setcountryselected((prev) => {
          return {
            ...prev,
            nationalityjoint1: { value: countryvalue },
            countryofbirthjoint1: { value: countryvalue },
          };
        });
      }
    }
    if (
      !!props.applicantparams.i_pangno3 &&
      props.applicantparams.i_pangno3.length > 0
    ) {
      const kycResponse = await props.getKycDetails({
        pan: props.applicantparams.i_pangno3,
      });
      if (!!kycResponse) {
        const { country, pin, GrossAnnualIncome, app_occ } =
          kycResponse.DtData[0];
        setCategoryOccupation((prev) => {
          return {
            ...prev,
            categoryoccupationjoint2: { value: app_occ },
          };
        });
        setPincode((prev) => {
          return {
            ...prev,
            value_joint2: { value: pin },
          };
        });
        setGross_Annual_Income((prev) => {
          return {
            ...prev,
            gross_annual_incomejoint2: { value: GrossAnnualIncome },
          };
        });
        const countryvalue =
          country.charAt(0).toUpperCase() + country.slice(1).toLowerCase();
        setcountryselected((prev) => {
          return {
            ...prev,
            nationalityjoint2: { value: countryvalue },
            countryofbirthjoint2: { value: countryvalue },
          };
        });
      }
    }
  };

  const handleRadioButton = (label) => (event) => {
    if (label === "TaxresidentPrimary") {
      setTax_resident((prev) => {
        return {
          ...prev,
          primary: event.target.value,
        };
      });
    }
    if (label === "PoliticallyExposedPersonPrimary") {
      setPolitically_Exposed_Applicant((prev) => {
        return {
          ...prev,
          primary: event.target.value,
        };
      });
    }
    if (label === "PoliticallyExposedRelativePrimary") {
      setPolitically_Exposed_Relative((prev) => {
        return {
          ...prev,
          primary: event.target.value,
        };
      });
    }
    if (label === "TaxresidentPrimaryjoint1") {
      setTax_resident((prev) => {
        return {
          ...prev,
          joint1: event.target.value,
        };
      });
    }
    if (label === "PoliticallyExposedPersonJoint1") {
      setPolitically_Exposed_Applicant((prev) => {
        return {
          ...prev,
          joint1: event.target.value,
        };
      });
    }
    if (label === "PoliticallyExposedRelativeJoint1") {
      setPolitically_Exposed_Relative((prev) => {
        return {
          ...prev,
          joint1: event.target.value,
        };
      });
    }
    if (label === "TaxresidentPrimaryjoint2") {
      setTax_resident((prev) => {
        return {
          ...prev,
          joint2: event.target.value,
        };
      });
    }
    if (label === "PoliticallyExposedPersonJoint2") {
      setPolitically_Exposed_Applicant((prev) => {
        return {
          ...prev,
          joint2: event.target.value,
        };
      });
    }
    if (label === "PoliticallyExposedRelativeJoint2") {
      setPolitically_Exposed_Relative((prev) => {
        return {
          ...prev,
          joint2: event.target.value,
        };
      });
    }
  };
  const handlePincode = (label) => (event) => {
    const value = event.target.value;
    if (label === "pincode1" && value.length <= 6) {
      if (value.length < 6) {
        setPincode({
          value: {
            value: "",
            isError: true,
            errorMessage: "Enter valid Pincode",
          },
        });
      }
      setPincode({ ...pincode, value: { value: value } });
    }
  };

  const TINValidatedRef = {
    primary: "N",
    joint1: "N",
    joint2: "N",
  };

  const checkingTINIdNumber = async (holder,countryCode, identityCode, tinNumber) => {
  
    const payload = {
      CountryCode: countryCode,
      IdTypeCode: identityCode,
      TINNo: tinNumber,
      TINFormat: "Individuals",
    };
  
    try {
      const response = await props.validateTINNumber(payload);
      const statusCode = response?.statusCode;
      const resMessage =
        response?.responseModel?.[0]?.resMessage || response?.statusMessage;
  
      if (statusCode === "200") {
        TINValidatedRef[holder] = "Y";  // ✅ update for that holder

        return true;
      } else {
        alert(resMessage);
        return false;
      }
    } catch (err) {
      console.error("TIN check failed", err);
      alert("TIN validation failed. Please try again.");
      return false;
    }
  };

  const submit = async () => {
    if (categoryoccupation.categoryoccupationprimary.value == "") {
      setCategoryOccupation({
        ...categoryoccupation,
        categoryoccupationprimary: {
          isError: true,
          errorMessage: "Select the occupation",
        },
      });
      return;
    }
    if (tax_resident.primary == "yes" && !tin_identification_type.primary.value) {
      settin_identification_type({
        ...tin_identification_type,
        primary: {
          value: "",
          isError: true,
          errorMessage: "Select Tin Identification Type",
        },
      });
      return;
    }
    if (gross_annual_income.gross_annual_incomeprimary.value == "") {
      setGross_Annual_Income({
        ...gross_annual_income,
        gross_annual_incomeprimary: {
          isError: true,
          errorMessage: "Select the Annual Income",
        },
      });
      return;
    }
    if (countryselected.countryofbirth.value == "") {
      setcountryselected({
        ...countryselected,
        ...countryselected,
        countryofbirth: {
          isError: true,
          errorMessage: "Select the Country of Birth",
        },
      });
      return;
    }
    if (countryselected.nationality.value == "") {
      setcountryselected({
        ...countryselected,
        nationality: {
          isError: true,
          errorMessage: "Select the Nationality",
        },
      });
      return;
    }
    if (
      tax_resident.primary == "yes" &&
      tax_resident_option.primary.value == ""
    ) {
      settax_resident_option({
        ...tax_resident_option,
        primary: {
          isError: true,
          errorMessage: "Select the Tax Resident",
        },
      });
      return;
    }
    if (
      tax_resident.primary == "yes" &&
      foreign_tax_id_no.primary.value == ""
    ) {
      setforeign_tax_id_no({
        ...foreign_tax_id_no,
        primary: {
          isError: true,
          errorMessage: "Enter the Foreign Tax ID No",
        },
      });
      return;
    }
    if (tax_resident.joint1 == "yes" && !tin_identification_type.joint1.value) {
        settin_identification_type({
          ...tin_identification_type,
          joint1: {
            value: "",
            isError: true,
            errorMessage: "Select Tin Identification Type",
          },
        });
        return;
      }
    if (pincode?.value?.value?.length <= 5) {
      setPincode({
        ...pincode,
        value: {
          isError: true,
          errorMessage: "Please enter a valid 6-digit PIN code",
        },
      });
      return;
    }
    if (!!props.applicantparams && !!props.applicantparams.i_pangno2) {
      if (categoryoccupation.categoryoccupationjoint1.value == "") {
        setCategoryOccupation({
          ...categoryoccupation,
          categoryoccupationjoint1: {
            isError: true,
            errorMessage: "Select the occupation",
          },
        });
        return;
      }
      if (gross_annual_income.gross_annual_incomejoint1.value == "") {
        setGross_Annual_Income({
          ...gross_annual_income,
          gross_annual_incomejoint1: {
            isError: true,
            errorMessage: "Select the Annual Income",
          },
        });
        return;
      }
      if (tax_resident.joint2 == "yes" && !tin_identification_type.joint2.value) {
        settin_identification_type({
          ...tin_identification_type,
          joint2: {
            value: "",
            isError: true,
            errorMessage: "Select Tin Identification Type",
          },
        });
        return;
      }
      if (countryselected.countryofbirthjoint1.value == "") {
        setcountryselected({
          ...countryselected,
          countryofbirthjoint1: {
            isError: true,
            errorMessage: "Select the Country of Birth",
          },
        });
        return;
      }
      if (countryselected.nationalityjoint1.value == "") {
        setcountryselected({
          ...countryselected,
          nationalityjoint1: {
            isError: true,
            errorMessage: "Select the Nationality",
          },
        });
        return;
      }
      if (
        tax_resident.joint1 == "yes" &&
        tax_resident_option.joint1.value == ""
      ) {
        settax_resident_option({
          ...tax_resident_option,
          joint1: {
            isError: true,
            errorMessage: "Select the Tax Resident",
          },
        });
        return;
      }
      if (
        tax_resident.joint1 == "yes" &&
        foreign_tax_id_no.joint1.value == ""
      ) {
        setforeign_tax_id_no({
          ...foreign_tax_id_no,
          joint1: {
            isError: true,
            errorMessage: "Enter the Foreign Tax ID No",
          },
        });
        return;
      }
      if (pincode.value_joint1.value.length <= 5) {
        setPincode({
          ...pincode,
          value_joint1: {
            isError: true,
            errorMessage: "Please enter a valid 6-digit PIN code",
          },
        });
        return;
      }
    }
    if (!!props.applicantparams && !!props.applicantparams.i_pangno3) {
      if (categoryoccupation.categoryoccupationjoint2.value == "") {
        setCategoryOccupation({
          ...categoryoccupation,
          categoryoccupationjoint2: {
            isError: true,
            errorMessage: "Select the occupation",
          },
        });
        return;
      }
      if (gross_annual_income.gross_annual_incomejoint2.value == "") {
        setGross_Annual_Income({
          ...gross_annual_income,
          gross_annual_incomejoint2: {
            isError: true,
            errorMessage: "Select the Annual Income",
          },
        });
        return;
      }
      if (countryselected.countryofbirthjoint2.value == "") {
        setcountryselected({
          ...countryselected,
          countryofbirthjoint2: {
            isError: true,
            errorMessage: "Select the Country of Birth",
          },
        });
        return;
      }
      if (countryselected.nationalityjoint2.value == "") {
        setcountryselected({
          ...countryselected,
          nationalityjoint2: {
            isError: true,
            errorMessage: "Select the Nationality",
          },
        });
        return;
      }
      if (
        tax_resident.joint2 == "yes" &&
        tax_resident_option.joint2.value == ""
      ) {
        settax_resident_option({
          ...tax_resident_option,
          joint2: {
            isError: true,
            errorMessage: "Select the Tax Resident",
          },
        });
        return;
      }
      if (
        tax_resident.joint2 == "yes" &&
        foreign_tax_id_no.joint2.value == ""
      ) {
        setforeign_tax_id_no({
          ...foreign_tax_id_no,
          joint2: {
            isError: true,
            errorMessage: "Enter the Foreign Tax ID No",
          },
        });
        return;
      }
      if (pincode.value_joint2.value.length <= 5) {
        setPincode({
          ...pincode,
          value_joint2: {
            isError: true,
            errorMessage: "Please enter a valid 6-digit PIN code",
          },
        });
        return;
      }
    }
    if (panverification) {
      setOpenModal(!openModal);
      return;
    }
    if (
      tax_resident &&
      foreign_tax_id_no &&
      tin_identification_type &&
      tax_resident_option
    ) {
      for (const [index, key] of ["primary", "joint1", "joint2"].entries()) {
        const hasPan =
          index === 0 ||
          (index === 1 && props.applicantparams.i_pangno2) ||
          (index === 2 && props.applicantparams.i_pangno3);
    
        if (
          hasPan &&
          tax_resident?.[key] === "yes" &&
          foreign_tax_id_no?.[key]?.value &&
          tin_identification_type?.[key]?.idTypeCode
        ) {
          const ok = await checkingTINIdNumber(
            key,  
            tax_resident_option?.[key]?.countryCode,
            tin_identification_type?.[key]?.idTypeCode,
            foreign_tax_id_no?.[key]?.value
          );
    
          if (!ok) {
            return;
          }
        }
      }
    }

    setIsLoading(true);
    const fatcaDetails = {
      TINValidated:TINValidatedRef.value,
      i_Occpn: categoryoccupation.categoryoccupationprimary.value,
      i_income: gross_annual_income.gross_annual_incomeprimary.value,
      FCountryofBirth: countryselected.countryofbirth.value,
      FNationality: countryselected.nationality.value,
      i_invpin: pincode.value.value,
      FPEP: politically_exposed_applicant.primary,
      FPREP: politically_exposed_relative.primary,
      FTaxResident: tax_resident.primary,
      FForeignTaxType:
        tax_resident.primary == "yes" ? tax_resident_option.primary.value : "",
      FForeignTaxId:
        tax_resident.primary == "yes" ? foreign_tax_id_no.primary.value : "",
      FFTIdentificationType:tin_identification_type.primary.idTypeCode,
        FTINValidated:TINValidatedRef.primary === "Y"?"Y":"N",
      FCountryCode:tax_resident_option.primary.countryCode,
      ...(props.applicantparams.i_genMOH === "4" &&
        props.applicantparams.i_pangno2 && {
          i_SOccpn: categoryoccupation.categoryoccupationjoint1.value,
          i_Sincome: gross_annual_income.gross_annual_incomejoint1.value,
          SCountryofBirth: countryselected.countryofbirthjoint1.value,
          SNationality: countryselected.nationalityjoint1.value,
          i_invpin2: pincode.value_joint1.value,
          SForeignTaxType:
            tax_resident.joint1 == "yes"
              ? tax_resident_option.joint1.value
              : "",
          STaxResident: tax_resident.joint1,
          SForeignTaxId:
            tax_resident.joint1 == "yes" ? foreign_tax_id_no.joint1.value : "",
          SForeignTinIdentificationType:tin_identification_type.joint1.idTypeCode,
          SPEP: politically_exposed_applicant.joint1,
          SPREP: politically_exposed_relative.joint1,
          SFTIdentificationType:tin_identification_type.joint1.idTypeCode,
          STINValidated:TINValidatedRef.joint1 === "Y"?"Y":"N",
          SCountryCode:tax_resident_option.joint1.countryCode,
        }),
      ...(props.applicantparams.i_genMOH === "4" &&
        props.applicantparams.i_pangno3 && {
          i_TOccpn: categoryoccupation.categoryoccupationjoint2.value,
          i_Tincome: gross_annual_income.gross_annual_incomejoint2.value,
          TCountryofBirth: countryselected.countryofbirthjoint2.value,
          TNationality: countryselected.nationalityjoint2.value,
          i_invpin3: pincode.value_joint2.value,
          TForeignTaxType:
            tax_resident.joint2 == "yes"
              ? tax_resident_option.joint2.value
              : "",
          TForeignTinIdentificationType:tin_identification_type.joint2.idTypeCode,
          TTaxResident: tax_resident.joint2,
          TForeignTaxId:
            tax_resident.joint2 == "yes" ? foreign_tax_id_no.joint2.value : "",
          TPEP: politically_exposed_applicant.joint2,
          TPREP: politically_exposed_relative.joint2,
          TFTIdentificationType:tin_identification_type.joint2.idTypeCode,
          STINValidated:TINValidatedRef.joint2 === "Y"?"Y":"N",
          TCountryCode:tax_resident_option.joint2.countryCode,
        }),
    };
    props.storeFatcaDetails(fatcaDetails);
    setIsLoading(false);
    props.history.replace("/new-investor-transaction/nominee-details");
  };

  return (
    <>
      <CustomLoader display={isLoading} />
      <CardComponent title="FATCA Details">
        <div>
          <div className="input-name">Primary Holder :</div>
          <div
            className={`new-investor-container ${
             tax_resident.primary === "yes" ? "tax-yes" : "tax-no"
            }`}
            style={{
              padding: "10px 0px 10px 0px",
              margin: "10px 0px 10px 0px",
              border: "2px solid #e5f2f9",
            }}
          >
            <div className="fatca-input-margin">
              <CustomizedSelect
                name="Occupation *"
                value={categoryoccupation.categoryoccupationprimary.value}
                fatcawidth={"true"}
                handleChange={(event) =>
                  setCategoryOccupation({
                    ...categoryoccupation,
                    categoryoccupationprimary: { value: event.target.value },
                  })
                }
                isError={categoryoccupation.categoryoccupationprimary.isError}
                errorMessage={
                  categoryoccupation.categoryoccupationprimary.errorMessage
                }
                placeholder={"Select One"}
              >
                {Occupations.map((item, index) => (
                  <MenuItem value={item.value} key={index}>
                    {item.label}
                  </MenuItem>
                ))}
              </CustomizedSelect>
            </div>{" "}
            <div className="fatca-input-margin">
              <CustomizedSelect
                name="Gross Annual Income *"
                value={gross_annual_income.gross_annual_incomeprimary.value}
                fatcawidth={"true"}
                handleChange={(event) =>
                  setGross_Annual_Income({
                    ...gross_annual_income,
                    gross_annual_incomeprimary: { value: event.target.value },
                  })
                }
                isError={gross_annual_income.gross_annual_incomeprimary.isError}
                errorMessage={
                  gross_annual_income.gross_annual_incomeprimary.errorMessage
                }
                placeholder={"Select One"}
              >
                {Gross_Annual_income.map((item, index) => (
                  <MenuItem value={item.value} key={index}>
                    {item.value}
                  </MenuItem>
                ))}
              </CustomizedSelect>
            </div>
            <div className="fatca-input-margin">
              <CustomizedSelect
                name="Country of Birth *"
                placeholder={"Select One"}
                value={countryselected.countryofbirth.value}
                fatcawidth={"true"}
                handleChange={(event) =>
                  setcountryselected({
                    ...countryselected,
                    countryofbirth: { value: event.target.value },
                  })
                }
                isError={countryselected.countryofbirth.isError}
                errorMessage={countryselected.countryofbirth.errorMessage}
              >
                {countriesList.map((item, index) => (
                  <MenuItem value={item.value} key={index}>
                    {item.value}
                  </MenuItem>
                ))}
              </CustomizedSelect>
            </div>
            <div className="fatca-input-margin">
              <CustomizedSelect
                name="Country of Citizenship/Nationality *"
                fatcawidth={"true"}
                placeholder={"Select One"}
                value={countryselected.nationality.value}
                handleChange={(event) =>
                  setcountryselected({
                    ...countryselected,
                    nationality: { value: event.target.value },
                  })
                }
                //   isError={countryselected.nationality.isError}
                // errorMessage={countryselected.nationality.errorMessage}
                isError={countryselected.nationality.isError}
                errorMessage={countryselected.nationality.errorMessage}
              >
                {countriesList.map((item, index) => (
                  <MenuItem value={item.value} key={index}>
                    {item.value}
                  </MenuItem>
                ))}
              </CustomizedSelect>
            </div>
            <div className="fatca-input-margin">
              <Input
                name={
                  props.applicantparams.i_category === "20"
                    ? "ZIP Code*"
                    : "Pin Code*"
                }
                type="number"
                value={pincode.value.value}
                onChange={handlePincode("pincode1")}
                fatcawidth={"true"}
                isShowError={pincode.value.isError}
                errorMessage={pincode.value.errorMessage}
              />
            </div>
            <RadioButton
              Heading="Tax Resident of any country other than India *"
              value={tax_resident.primary}
              onChange={handleRadioButton("TaxresidentPrimary")}
            />
            {tax_resident.primary == "yes" && (
              <div className="tax-extra-column">
              <div className="fatca-input-margin">
                  <CustomizedSelect
                    name="Tax Resident*"
                    value={tax_resident_option.primary.value}
                    handleChange={(event) =>{
                      const selected = tincountriesList.find(
                        (c) => c.value === event.target.value
                      );
                      settax_resident_option({
                        ...tax_resident_option,
                        primary: {
                          value: selected?.value || "",
                          countryCode: selected?.countryCode || "",
                        },
                      })
                    }
                    }
                    fatcawidth={"true"}
                    placeholder={"Select One"}
                    isError={tax_resident_option.primary.isError}
                    errorMessage={tax_resident_option.primary.errorMessage}
                  >
                    {tincountriesList.map((item, index) => (
                      <MenuItem value={item.value} key={index}>
                        {item.value}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                </div>
                <div className="fatca-input-margin">
                <CustomizedSelect
                        name="Tin Identification Type*"
                        placeholder={"Select One"}
                        value={tin_identification_type.primary.value}
                        handleChange={(event) => {
                          const selected = tinidentificationList.find(
                            (c) => c.value === event.target.value
                          );
                          settin_identification_type({
                            ...tin_identification_type,
                            primary: {
                              value: selected?.value || "",
                              idTypeCode: selected?.idTypeCode || "",
                            },
                          });
                        }}
                        fatcawidth={"true"}
                        isError={tin_identification_type.primary.isError}
                        errorMessage={tin_identification_type.primary.errorMessage}
                      >
                        {tinidentificationList.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.value}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                <div cclassName="fatca-input-margin" style={{marginLeft:20}}>
                  <Input
                    name="Foreign Tax ID No*"
                    value={foreign_tax_id_no.primary.value}
                    onChange={(event) =>
                      setforeign_tax_id_no({
                        ...foreign_tax_id_no,
                        primary: { value: event.target.value },
                      })
                    }
                    fatcawidth={"true"}
                    isShowError={foreign_tax_id_no.primary.isError}
                    errorMessage={tax_resident_option.primary.errorMessage}
                  />
                </div>
              </div>
            )}
            <RadioButton
              Heading="Politically Exposed Person"
              value={politically_exposed_applicant.primary}
              onChange={handleRadioButton("PoliticallyExposedPersonPrimary")}
            />
            <RadioButton
              Heading="Politically Exposed Relative"
              value={politically_exposed_relative.primary}
              onChange={handleRadioButton("PoliticallyExposedRelativePrimary")}
            />
          </div>
        </div>
        {!!props.applicantparams.i_pangno2 &&
          props.applicantparams.i_pangno2.length > 0 && (
            <div>
              <div className="input-name">First Joint Holder :</div>
              <div
                className={`new-investor-container ${
                  tax_resident.joint1 === "yes" ? "tax-yes" : "tax-no"
                }`}
                style={{
                  padding: "10px 0px 10px 0px",
                  margin: "10px 0px 10px 0px",
                  border: "2px solid #e5f2f9",
                }}
              >
                <div className="fatca-input-margin">
                  <CustomizedSelect
                    name="Occupation *"
                    placeholder={"Select One"}
                    value={categoryoccupation.categoryoccupationjoint1.value}
                    fatcawidth={"true"}
                    handleChange={(event) =>
                      setCategoryOccupation({
                        ...categoryoccupation,
                        categoryoccupationjoint1: { value: event.target.value },
                      })
                    }
                    isError={
                      categoryoccupation.categoryoccupationjoint1.isError
                    }
                    errorMessage={
                      categoryoccupation.categoryoccupationjoint1.errorMessage
                    }
                  >
                    {Occupations.map((item, index) => (
                      <MenuItem value={item.value} key={index}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                </div>{" "}
                <div className="fatca-input-margin">
                  <CustomizedSelect
                    name="Gross Annual Income *"
                    placeholder={"Select One"}
                    value={
                      gross_annual_income.gross_annual_incomejoint1.value
                        ? gross_annual_income.gross_annual_incomejoint1.value
                        : "Select One"
                    }
                    fatcawidth={"true"}
                    handleChange={(event) =>
                      setGross_Annual_Income({
                        ...gross_annual_income,
                        gross_annual_incomejoint1: {
                          value: event.target.value,
                        },
                      })
                    }
                    isError={
                      gross_annual_income.gross_annual_incomejoint1.isError
                    }
                    errorMessage={
                      gross_annual_income.gross_annual_incomejoint1.errorMessage
                    }
                  >
                    {Gross_Annual_income.map((item, index) => (
                      <MenuItem value={item.value} key={index}>
                        {item.value}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                </div>
                <div className="fatca-input-margin">
                  <CustomizedSelect
                    placeholder={"Select One"}
                    name="Country of Birth *"
                    value={
                      countryselected.countryofbirthjoint1.value
                        ? countryselected.countryofbirthjoint1.value
                        : ""
                    }
                    fatcawidth={"true"}
                    handleChange={(event) =>
                      setcountryselected({
                        ...countryselected,
                        countryofbirthjoint1: { value: event.target.value },
                      })
                    }
                    isError={countryselected.countryofbirthjoint1.isError}
                    errorMessage={
                      countryselected.countryofbirthjoint1.errorMessage
                    }
                  >
                    {countriesList.map((item, index) => (
                      <MenuItem value={item.value} key={index}>
                        {item.value}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                </div>
                <div className="fatca-input-margin">
                  <CustomizedSelect
                    name="Country of Citizenship/Nationality *"
                    fatcawidth={"true"}
                    placeholder={"Select One"}
                    items={countriesList.map((item) => ({
                      label: item.label,
                      value: item.value,
                    }))}
                    value={
                      countryselected.nationalityjoint1.value
                        ? countryselected.nationalityjoint1.value
                        : ""
                    }
                    handleChange={(event) =>
                      setcountryselected({
                        ...countryselected,
                        nationalityjoint1: { value: event.target.value },
                      })
                    }
                    isError={countryselected.nationalityjoint1.isError}
                    errorMessage={
                      countryselected.nationalityjoint1.errorMessage
                    }
                  >
                    {countriesList.map((item, index) => (
                      <MenuItem value={item.value} key={index}>
                        {item.value}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                </div>
                <div className="fatca-input-margin">
                  <Input
                    name={
                      props.applicantparams.i_category2 === "20"
                        ? "ZIP Code*"
                        : "Pin Code*"
                    }
                    type="number"
                    value={
                      pincode.value_joint1.value
                        ? pincode.value_joint1.value
                        : ""
                    }
                    onChange={(event) =>
                      setPincode({
                        ...pincode,
                        value_joint1: { value: event.target.value },
                      })
                    }
                    fatcawidth={"true"}
                    isShowError={pincode.value_joint1.isError}
                    errorMessage={pincode.value_joint1.errorMessage}
                  />
                </div>
                <RadioButton
                  Heading="Tax Resident of any country other than India *"
                  value={tax_resident.joint1}
                  onChange={handleRadioButton("TaxresidentPrimaryjoint1")}
                />
                {tax_resident.joint1 == "yes" && (
                  <div className="tax-extra-column">
                    <div  className="fatca-input-margin">
                      <CustomizedSelect
                        name="Tax Resident*"
                        placeholder={"Select One"}
                        value={tax_resident_option.joint1.value}
                        handleChange={(event) =>{
                          const selected = tincountriesList.find(
                            (c) => c.value === event.target.value
                          );
                          settax_resident_option({
                            ...tax_resident_option,
                            joint1: {
                              value: selected?.value || "",
                              countryCode: selected?.countryCode || "",
                            },
                          })
                        }
                        }
                        fatcawidth={"true"}
                        isError={tax_resident_option.joint1.isError}
                        errorMessage={tax_resident_option.joint1.errorMessage}
                      >
                        {tincountriesList.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.value}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                    <div  className="fatca-input-margin">
                      <CustomizedSelect
                        name="Tin Identification Type*"
                        placeholder={"Select One"}
                        value={tin_identification_type.joint1.value}
                        handleChange={(event) => {
                          const selected = tinidentificationList.find(
                            (c) => c.value === event.target.value
                          );
                          settin_identification_type({
                            ...tin_identification_type,
                            joint1: {
                              value: selected?.value || "",
                              idTypeCode: selected?.idTypeCode || "",
                            },
                          });
                        }}
                        fatcawidth={"true"}
                        isError={tin_identification_type.joint1.isError}
                        errorMessage={tin_identification_type.joint1.errorMessage}
                      >
                        {tinidentificationList.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.value}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        name="Foreign Tax ID No*"
                        value={foreign_tax_id_no.joint1.value}
                        onChange={(event) =>
                          setforeign_tax_id_no({
                            ...foreign_tax_id_no,
                            joint1: { value: event.target.value },
                          })
                        }
                        fatcawidth={"true"}
                        isShowError={foreign_tax_id_no.joint1.isError}
                        errorMessage={tax_resident_option.joint1.errorMessage}
                      />
                    </div>
                  </div>
                )}
                <RadioButton
                  Heading=" Politically Exposed Person"
                  value={politically_exposed_applicant.joint1}
                  onChange={handleRadioButton("PoliticallyExposedPersonJoint1")}
                />
                <RadioButton
                  Heading=" Politically Exposed Relative"
                  value={politically_exposed_relative.joint1}
                  onChange={handleRadioButton(
                    "PoliticallyExposedRelativeJoint1"
                  )}
                />
              </div>
            </div>
          )}

        {!!props.applicantparams.i_pangno3 &&
          props.applicantparams.i_pangno3.length > 0 && (
            <div>
              <div className="input-name">Second Joint Holder :</div>
              <div
                className={`new-investor-container ${
                tax_resident.joint2 === "yes" ? "tax-yes" : "tax-no"
              }`}
                style={{
                  padding: "10px 0px 10px 0px",
                  margin: "10px 0px 10px 0px",
                  border: "2px solid #e5f2f9",
                }}
              >
                <div className="fatca-input-margin">
                  <CustomizedSelect
                    name="Occupation *"
                    placeholder={"Select One"}
                    value={categoryoccupation.categoryoccupationjoint2.value}
                    fatcawidth={"true"}
                    handleChange={(event) =>
                      setCategoryOccupation({
                        ...categoryoccupation,
                        categoryoccupationjoint2: { value: event.target.value },
                      })
                    }
                    isError={
                      categoryoccupation.categoryoccupationjoint2.isError
                    }
                    errorMessage={
                      categoryoccupation.categoryoccupationjoint2.errorMessage
                    }
                  >
                    {Occupations.map((item, index) => (
                      <MenuItem value={item.value} key={index}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                </div>{" "}
                <div className="fatca-input-margin">
                  <CustomizedSelect
                    name="Gross Annual Income *"
                    value={
                      gross_annual_income.gross_annual_incomejoint2.value
                        ? gross_annual_income.gross_annual_incomejoint2.value
                        : "Select One"
                    }
                    fatcawidth={"true"}
                    handleChange={(event) =>
                      setGross_Annual_Income({
                        ...gross_annual_income,
                        gross_annual_incomejoint2: {
                          value: event.target.value,
                        },
                      })
                    }
                    isError={
                      gross_annual_income.gross_annual_incomejoint2.isError
                    }
                    errorMessage={
                      gross_annual_income.gross_annual_incomejoint2.errorMessage
                    }
                    placeholder={"Select One"}
                  >
                    {Gross_Annual_income.map((item, index) => (
                      <MenuItem value={item.value} key={index}>
                        {item.value}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                </div>
                <div className="fatca-input-margin">
                  <CustomizedSelect
                    placeholder={"Select One"}
                    name="Country of Birth *"
                    value={
                      countryselected.countryofbirthjoint2.value
                        ? countryselected.countryofbirthjoint2.value
                        : ""
                    }
                    fatcawidth={"true"}
                    handleChange={(event) =>
                      setcountryselected({
                        ...countryselected,
                        countryofbirthjoint2: { value: event.target.value },
                      })
                    }
                    isError={countryselected.countryofbirthjoint2.isError}
                    errorMessage={
                      countryselected.countryofbirthjoint2.errorMessage
                    }
                  >
                    {countriesList.map((item, index) => (
                      <MenuItem value={item.value} key={index}>
                        {item.value}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                </div>
                <div className="fatca-input-margin">
                  <CustomizedSelect
                    placeholder={"Select One"}
                    name="Country of Citizenship/Nationality *"
                    fatcawidth={"true"}
                    items={countriesList.map((item) => ({
                      label: item.label,
                      value: item.value,
                    }))}
                    value={
                      countryselected.nationalityjoint2.value
                        ? countryselected.nationalityjoint2.value
                        : ""
                    }
                    handleChange={(event) =>
                      setcountryselected({
                        ...countryselected,
                        nationalityjoint2: { value: event.target.value },
                      })
                    }
                    isError={countryselected.nationalityjoint2.isError}
                    errorMessage={
                      countryselected.nationalityjoint2.errorMessage
                    }
                  >
                    {countriesList.map((item, index) => (
                      <MenuItem value={item.value} key={index}>
                        {item.value}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                </div>
                <div className="fatca-input-margin">
                  <Input
                    name={
                      props.applicantparams.i_category3 === "20"
                        ? "ZIP Code*"
                        : "Pin Code*"
                    }
                    type="number"
                    value={
                      pincode.value_joint2.value
                        ? pincode.value_joint2.value
                        : ""
                    }
                    onChange={(event) =>
                      setPincode({
                        ...pincode,
                        value_joint2: { value: event.target.value },
                      })
                    }
                    fatcawidth={"true"}
                    isShowError={pincode.value_joint2.isError}
                    errorMessage={pincode.value_joint2.errorMessage}
                  />
                </div>
                <RadioButton
                  Heading="Tax Resident of any country other than India *"
                  value={tax_resident.joint2}
                  onChange={handleRadioButton("TaxresidentPrimaryjoint2")}
                />
                {tax_resident.joint2 == "yes" && (
                  <div className="tax-extra-column">

                 <div className="fatca-input-margin">

                      <CustomizedSelect
                        placeholder={"Select One"}
                        name="Tax Resident*"
                        value={tax_resident_option.joint2.value}
                        handleChange={(event) =>{
                          const selected = tincountriesList.find(
                            (c) => c.value === event.target.value
                          );
                          settax_resident_option({
                            ...tax_resident_option,
                            joint2: {
                              value: selected?.value || "",
                              countryCode: selected?.countryCode || "",
                            },
                          })
                        }
                        }
                        fatcawidth={"true"}
                        isError={tax_resident_option.joint2.isError}
                        errorMessage={tax_resident_option.joint2.errorMessage}
                      >
                        {tincountriesList.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.value}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                    <div className="fatca-input-margin">
                    <CustomizedSelect
                        name="Tin Identification Type*"
                        placeholder={"Select One"}
                        value={tin_identification_type.joint2.value}
                        handleChange={(event) => {
                          const selected = tinidentificationList.find(
                            (c) => c.value === event.target.value
                          );
                          settin_identification_type({
                            ...tin_identification_type,
                            joint2: {
                              value: selected?.value || "",
                              idTypeCode: selected?.idTypeCode || "",
                            },
                          });
                        }}
                        fatcawidth={"true"}
                        isError={tin_identification_type.joint2.isError}
                        errorMessage={tin_identification_type.joint2.errorMessage}
                      >
                        {tinidentificationList.map((item, index) => (
                          <MenuItem value={item.value} key={index}>
                            {item.value}
                          </MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>
                    <div className="fatca-input-margin">
                      <Input
                        name="Foreign Tax ID No*"
                        value={foreign_tax_id_no.joint2.value}
                        onChange={(event) =>
                          setforeign_tax_id_no({
                            ...foreign_tax_id_no,
                            joint2: { value: event.target.value },
                          })
                        }
                        fatcawidth={"true"}
                        isShowError={foreign_tax_id_no.joint2.isError}
                        errorMessage={tax_resident_option.joint2.errorMessage}
                      />
                    </div>
                  </div>
                )}
                <RadioButton
                  Heading="Politically Exposed Person"
                  value={politically_exposed_applicant.joint2}
                  onChange={handleRadioButton("PoliticallyExposedPersonJoint2")}
                />
                <RadioButton
                  Heading="Politically Exposed Relative"
                  value={politically_exposed_relative.joint2}
                  onChange={handleRadioButton(
                    "PoliticallyExposedRelativeJoint2"
                  )}
                />
              </div>
            </div>
          )}
      </CardComponent>
      <div className="d-flex justify-content-end">
        <button
          className="new-investor-button new-investor-active"
          style={{ filter: "grayscale(1) opacity(0.4)" }}
          onClick={() =>
            props.history.replace("/new-investor-transaction/investor-details")
          }
        >
          BACK
        </button>
        <button
          className="new-investor-button new-investor-active"
          onClick={submit}
        >
          PROCEED
        </button>
      </div>
    </>
  );
};
export default connect(
  ({ newinvestor }) => {
    const { applicantparams, fatcaDetails, store_pan } = newinvestor;
    return {
      applicantparams,
      fatcaDetails,
      store_pan,
    };
  },
  {
    validateTINNumber,
    getTinCountries,
    getTinIdentificationList,
    storeFatcaDetails,
    getCountriesList,
    getStatesList,
    storeApplicantParams,
    getKycDetails,
    getCitiesByState,
    getRelationShipList,
    storeAddress,
  }
)(FatcaDetails);
